module.exports = __webpack_public_path__ + "img/mobile.d20767d72be8a4a6615017b33ba57345.png";